const moveScrollBackHistory = () => {
    const scrollValue = window.localStorage.getItem('scrollY');
    if (scrollValue) {
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: scrollValue,
            }, 500);
            $.spinner().stop();
        }, 500);

        $('.show-more button').removeAttr('disabled');
    } else {
        $.spinner().stop();
    }
};

module.exports = {
    backInHistory() {
        const defer = $.Deferred();
        const url = $('#isDynamic').attr('data-url');
        const environmentAvailable = $('#isDynamic').attr('data-available');

        const performance = window.performance.getEntriesByType('navigation');
        let eventType;
        if (typeof performance === 'object' && performance.length) {
            eventType = performance[0].type;
        }

        const windowURL = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}${window.location.search}`;

        if (url && url !== 'null' && environmentAvailable === 'true' && eventType === 'back_forward') {
            $.ajax({
                url,
                method: 'GET',
                success: (response) => {
                    if (response.redirectGridUrl) {
                        const urlResp = decodeURI(response.redirectGridUrl);
                        const windUrl = decodeURI(windowURL);


                        const urlParamsRedirect = new URLSearchParams(urlResp);
                        const urlRedirect = urlParamsRedirect.get('selectedUrl');
                        let urlRedirectDec;
                        if (urlRedirect) {
                            urlRedirectDec = decodeURI(urlRedirect);
                            if (urlRedirectDec && urlRedirectDec.indexOf('%3A%2F%2F') !== -1) {
                                urlRedirectDec = decodeURIComponent(urlRedirectDec);
                            }
                        }

                        const urlParamsWin = new URLSearchParams(windUrl);
                        let selectedUrlWin = urlParamsWin.get('selectedUrl');
                        if (selectedUrlWin && selectedUrlWin.indexOf('%3A%2F%2F') !== -1) {
                            selectedUrlWin = decodeURIComponent(selectedUrlWin);
                        }


                        if (urlRedirectDec && urlRedirectDec !== selectedUrlWin) {
                            defer.resolve({ redirectURL: response.redirectGridUrl });
                        } else {
                            defer.resolve({ redirectURL: null });
                        }
                    } else {
                        defer.resolve({ redirectURL: null });
                    }
                },
                error: () => {
                    defer.resolve({ redirectURL: null });
                },
            });
        } else {
            defer.resolve({ redirectURL: null });
        }

        return defer;
    },

    moveScrollBackInHistory() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const selectedUrl = urlParams.get('selectedUrl');
        if (selectedUrl) {
            setTimeout(() => {
                moveScrollBackHistory();
            }, 1000);
        } else {
            $.spinner().stop();
        }
    },
};
